
export const isValidSource = (src, type) => {
  let isValid = false;
  const source = (src || '');
  const startValid = source.startsWith('https://kiki-beta.oss-ap-southeast-1.aliyuncs.com/') ||
  source.startsWith('https://kiki-prod.oss-ap-southeast-1.aliyuncs.com/')
  //  || source.startsWith('https://kiki-beta.oss-ap-southeast-1.aliyuncs.com/');
  switch (type) {
    case 'image': {
      const endValid = /\.(png|jpg|xbm|tif|pjp|svgz|jpeg|ico|tiff|gif|svg|jfif|webp|bmp|pjpeg|avif)$/
        .test(source.toLocaleLowerCase());
      isValid = startValid && endValid;
      break;
    }
    case 'video': {
      const endValid = /\.(mpg|mpeg|avi|rm|rmvb|mov|wmv|asf|dat|mp4)$/.test(source.toLocaleLowerCase());
      isValid = startValid && endValid;
      break;
    }
  }
  return isValid;
}

// 获取富文本内容
export const getInnerText = (htm) => {
  let div = document.createElement('div');
  div.innerHTML = htm;
  const text = div.innerText;
  div = null;
  return text || '';
};
